<template>
  <span 
    :class="['tag', cor, { 'is-clickable': isClicavel }]"
    @click="handleClick"
    v-e2e="'trf-tag'"
  >
    {{ texto }}
  </span>
</template>

<script>
export default {
  name: 'TrfTag',
  props: {
    /**
     * Texto exibido na tag
     */
    texto: {
      type: String,
      required: true
    },
    /**
     * Classe Bulma de cor (ex: 'is-primary', 'is-success', 'is-danger')
     */
    cor: {
      type: String,
      default: ''
    },
    /**
     * Define se a tag é clicável
     */
    isClicavel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    handleClick() {
      if (this.isClicavel) {
        this.$emit('click', this.texto);
      }
    }
  }
};
</script>

<style scoped>
.tag.is-clickable {
  cursor: pointer;
  transition: opacity 0.2s;
}

.tag.is-clickable:hover {
  opacity: 0.8;
}

.tag {
  border-radius: 1rem;
}
</style>
